import React, { useEffect } from "react";
import { Button, Card, Layout, Table } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { EmployeeDlg } from "./EmployeeDlg";
import { Toolbar } from "../../../components/Toolbar";
import { useEmployees } from "../../../hooks/system/useEmployees";
import { useEditEmployee } from "../../../hooks/system/useEditEmployee";

export const Employees = () => {
  const { refresh, employees, loading, roles } = useEmployees();
  const { add, edit, ...editEmployee } = useEditEmployee({ refresh });

  useEffect(() => {
    refresh();
  }, []);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      defaultSortOrder: "ascend" as const,
      sorter: (a, b) => (a.title || "").localeCompare(b.title || ""),
    },
    {
      title: "Employee Name",
      key: "username",
      sorter: (a, b) => (a.name || a.email).localeCompare(b.name || b.email),
      render: (_, r) => r.name || r.email,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      render: (val) => (val || []).join(", "),
      sorter: (a, b) => (a.roles || []).join(", ").localeCompare((b.roles || []).join(", ")),
    },
    {
      title: "Enabled",
      dataIndex: ["poolInfo", "enabled"],
      key: "enabled",
      render: (val) => (val ? "Active" : "In-active"),
      sorter: (a, b) => (a.poolInfo.enabled ? 0 : 1) - (b.poolInfo.enabled ? 0 : 1),
    },
    {
      title: "Status",
      dataIndex: ["poolInfo", "status"],
      key: "status",
      sorter: (a, b) => a.poolInfo?.status?.localeCompare(b.poolInfo?.status),
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => edit(r.id)} />,
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button type="primary" size="large" icon={<PlusOutlined />} onClick={add}>
            New Employee
          </Button>
        }
      ></Toolbar>
      <Card size="small" bodyStyle={{ padding: 0 }} style={{ marginTop: 16 }}>
        <Table size="small" loading={loading} rowKey="id" columns={columns} dataSource={employees} pagination={false} />
        <EmployeeDlg roles={roles} {...editEmployee} />
      </Card>
    </Layout.Content>
  );
};
